// Copyright 2021-2024, 2026 - Hewlett Packard Enterprise Company
import { useHistory } from 'react-router-dom';
import { AuthConsumer } from '../providers/AuthProvider';
import { postLoginRedirect } from '../utils/authHelpers';

export default function AuthCallback() {
  const history = useHistory();
  return (
    <AuthConsumer>
      {({ signinRedirectCallback }) => {
        signinRedirectCallback()
          .then(() => {
            postLoginRedirect(history);
          })
          .catch(() => {
            // TODO: Possibly display an error message with a link to GLP login page.
            // eslint-disable-next-line no-console
            console.log('Unable to authenticate user. Redirect to CCS login');
          });
        return <span>Authenticating ...</span>;
      }}
    </AuthConsumer>
  );
}
